
import author from '@/mixins/author-data.js'
import seo from '@/mixins/seo.js'
import helpers from '@/mixins/helpers.js'

export default {
  name: 'Authors',
  mixins: [author, seo, helpers],
}
